var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "map-container" },
    [
      _c(
        "client-only",
        [
          _c(
            "l-map",
            {
              staticStyle: { height: "100%" },
              attrs: {
                zoom: 2,
                "min-zoom": 2,
                center: [51.5285582, -0.2416784],
              },
            },
            [
              _c("l-tile-layer", {
                attrs: {
                  url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.mapData, function (mapItem, index) {
                return _c("l-circle-marker", {
                  key: index,
                  attrs: {
                    "lat-lng": [mapItem.lat, mapItem.long],
                    fill: true,
                    radius: _vm.calculateRadius(mapItem.count),
                    "fill-opacity": _vm.checkSubsAccess(mapItem) ? 1 : 0.9,
                    "fill-color": _vm.checkSubsAccess(mapItem)
                      ? _vm.circle.color
                      : _vm.circle.colorRestricted,
                    color: _vm.checkSubsAccess(mapItem)
                      ? _vm.circle.color
                      : _vm.circle.colorRestricted,
                    title: "mapItem.name",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.openPopUp(
                        [mapItem.lat, mapItem.long],
                        mapItem.name,
                        mapItem.updates,
                        mapItem.count,
                        mapItem.tid,
                        mapItem.subscribed,
                        "circle"
                      )
                    },
                  },
                })
              }),
              _vm._v(" "),
              _c(
                "l-layer-group",
                { ref: "features" },
                [
                  _c(
                    "l-popup",
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "map-badge mark",
                          attrs: { value: _vm.popup.count, max: 10 },
                        },
                        [_c("h1", [_vm._v(_vm._s(_vm.popup.title))])]
                      ),
                      _vm._v(" "),
                      _vm.checkSubsAccess(_vm.popup, true)
                        ? _c(
                            "ul",
                            _vm._l(_vm.popup.updates, function (item, index) {
                              return _c(
                                "li",
                                { key: index, staticClass: "updates list" },
                                [
                                  _c(
                                    "nuxt-link",
                                    {
                                      attrs: { to: item.url, target: "_blank" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.name) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _c("ul", [
                            _c("li", { staticClass: "updates list" }, [
                              _vm._v(
                                "\n              Please contact\n              "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "mailto:clientvalue@vixio.com",
                                  },
                                },
                                [_vm._v("clientvalue@vixio.com")]
                              ),
                              _vm._v(
                                "\n              to activate this jurisdiction.\n            "
                              ),
                            ]),
                          ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }